import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFacebook = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m20.155 10.656-1.506.001c-1.181 0-1.41.561-1.41 1.384v1.816h2.817l-.367 2.845h-2.45V24h-2.937v-7.298h-2.456v-2.845h2.456V11.76c0-2.435 1.487-3.76 3.658-3.76 1.04 0 1.934.077 2.195.112zM16 0C7.164 0 0 7.163 0 16s7.164 16 16 16 16-7.164 16-16S24.837 0 16 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFacebook);

export default ForwardRef;
